import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiTypography = (
  theme: Theme,
): BackstageOverrides['MuiTypography'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      color: tokens.textPrimary,
    },
    button: {
      fontWeight: 700,
      lineHeight: '16px',
      textTransform: 'none',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '2rem',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '1.625rem',
    },
    subtitle1: {
      fontSize: '1rem',
      lineHeight: '1.375rem',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: '1.125rem',
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
    },
  };
};
